import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { PARA_QUIEN_NO, PARA_QUIEN_SI } from '../../data/content';
export function ForWho() {
  return <section className="bg-crema py-16 sm:py-20 px-5" data-id="element-134" data-mp="1jggii6okw8o5">
      <div className="max-w-5xl mx-auto grid gap-6 md:grid-cols-2" data-id="element-135" data-mp="1em2skjsoqtqv">
        <div className="rounded-3xl bg-white border-2 border-coral p-7" data-id="element-136" data-mp="1ambudv0txbcb">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold text-violeta" data-id="element-137" data-mp="1ajzcfhv2n0z9">Esto es para vos si…</h2>
          <ul className="mt-6 space-y-4" data-id="element-138" data-mp="10nmcw3cuhswl">
            {PARA_QUIEN_SI.map(item => <li key={item} className="flex items-start gap-3" data-id="element-139" data-mp="10pz12y974zi3">
                <CheckCircle2Icon className="w-5 h-5 text-coral shrink-0 mt-1" aria-hidden="true" data-id="element-140" data-mp="vp1lmtfkmjka" />
                <span className="text-base sm:text-lg text-tinta" data-id="element-141" data-mp="roiqapegyvdc">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl bg-crema-alt border border-black/10 p-7" data-id="element-142" data-mp="2m0z5ifp8tjuc">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold text-tinta/60" data-id="element-143" data-mp="2lyurh4xmr4gc">
            Esto no es para vos si…
          </h2>
          <ul className="mt-6 space-y-4" data-id="element-144" data-mp="hpjwnrensail">
            {PARA_QUIEN_NO.map(item => <li key={item} className="flex items-start gap-3" data-id="element-145" data-mp="3q22ewilg51u">
                <XCircleIcon className="w-5 h-5 text-tinta/40 shrink-0 mt-1" aria-hidden="true" data-id="element-146" data-mp="3rv92bt7ip9u" />
                <span className="text-base sm:text-lg text-tinta/65" data-id="element-147" data-mp="7rxd2rmezusa">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}